<template>
  <v-container>
    <v-menu>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
              mdi-dots-vertical
            </v-icon>
          </template>
          <span>Acciones</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="seleccionarComponent(item)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="desplegarPedido"> Ver pedido </v-list-item>
        <v-list-item @click="imprimirPedido"> Imprimir pedido </v-list-item>
        <v-list-item @click="descargarPDF"> Descargar PDF</v-list-item>
        <v-list-item @click="dialogVerFacturasPendientesView = true">
          Facturas pendientes
        </v-list-item>
        <v-list-item v-if="item.abierto" @click="cambiarPrioridad">
          Cambiar prioridad
        </v-list-item>
        <v-list-item
          v-if="item.abierto"
          @click="dialogRegresarPedido = !dialogRegresarPedido"
        >
          Regresar pedido
        </v-list-item>

        <!-- <v-list-item> Enviar por Whatsapp </v-list-item>
        <v-list-item> Enviar por correo </v-list-item> -->

        <!-- <v-list-item @click="crearCotizacion"> Cotización </v-list-item> -->
        <v-list-item v-if="item.abierto" @click="cancelarPedido">
          Cancelar pedido
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog scrollable max-width="60%" v-model="dialog">
      <v-card v-if="selectedComponent === 'AsociarFactura'">
        <AsociarFactura
          :item="item"
          @pedidoModificado="pedidoModificado"
          @cerrarDialog="cerrarDialog"
        />
      </v-card>
      <v-card v-if="selectedComponent === 'CrearComentario'">
        <CrearComentario :item="item" @pedidoModificado="pedidoModificado" />
      </v-card>
    </v-dialog>
    <!-- Dialog para ver el pedido -->
    <v-dialog
      fullscreen
      transition="dialog-bottom-transition"
      v-model="dialogVerPedido"
    >
      <VerPedido
        :item="item"
        :usuarios="usuarios"
        :comentarios="comentariosPedido"
        @cerrarDialog="cerrarDialog"
      />
    </v-dialog>

    <v-dialog
      fullscreen
      transition="dialog-top-transition"
      v-model="dialogVerFacturasPendientesView"
    >
      <verFacturasPendientesView
        :item="item"
        :usuarios="usuarios"
        @cerrarDialog="cerrarDialog"
      />
    </v-dialog>

    <v-dialog v-model="dialogRegresarPedido" max-width="500px">
      <v-card>
        <v-card-title> Regresar pedido a: </v-card-title>
        <v-card-text>
          <v-select label="Estado" v-model="estado" :items="estados"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="regresarPedido">
            Regresar pedido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import AsociarFactura from "./AsociarFactura.vue";
import VerPedido from "./VerPedido.vue";
import verFacturasPendientesView from "@/views/verFacturasPendientesView.vue";
import CrearComentario from "./CrearComentario.vue";
import moment from "moment";
import html2pdf from "html2pdf.js";

export default {
  props: ["item", "usuarios"],
  components: {
    AsociarFactura,
    VerPedido,
    CrearComentario,
    verFacturasPendientesView,
  },
  data() {
    return {
      dialog: false,
      dialogRegresarPedido: false,
      dialogVerFacturasPendientesView: false,
      dialogVerPedido: false,
      items: [],
      selectedComponent: null,
      formatDate: "",
      estado: "",
      logoURL: require("@/assets/log.png"),
      visamastercard: require("@/assets/visa-mastercard.png"),
      estados: [
        {
          text: "Preparación en almacén",
          value: "preparacion_en_almacen",
        },
        {
          text: "Preparado",
          value: "preparado",
        },
      ],
      comentariosPedido: [],
      comentariosImpresion: [],
      historial: [],
      autorizaPedido: "",
      telefonos: [],
      rfc: "",
      FechaConfirmacion: "",
    };
  },
  methods: {
    async imprimirPedido() {
      await this.getComentarios(this.item.id);
      await this.getHistorialObjeto(this.item.id);
      await this.getClienteTelefonosyRFC(this.item.idCliente);

      const pedido = this.item; // Datos del pedido
      const productos = this.item.productos.lista_productos; // Lista de productos

      const subtotal = productos.reduce(
        (acc, p) => acc + p.precio * p.cantidad,
        0,
      );

      const totalIeps = productos.reduce(
        (acc, p) => acc + p.precio * p.cantidad * (p.ieps / 100),
        0,
      );

      const totalIva = productos.reduce(
        (acc, p) => acc + p.precio * p.cantidad * (p.iva / 100),
        0,
      );

      /*const localizacion =
        pedido.localizacion.direccion_linea_1 +
        ", " +
        pedido.localizacion.direccion_linea_2 +
        ", " +
        pedido.localizacion.ciudad +
        " C.P. " +
        pedido.localizacion.codigo_postal;*/

      const loc = pedido.localizacion;

      const partes = [
        loc?.direccion_linea_1,
        loc?.direccion_linea_2,
        loc?.ciudad,
      ].filter(Boolean);

      if (loc?.codigo_postal) {
        partes.push(`C.P. ${loc.codigo_postal}`);
      }

      const localizacion = partes.length ? partes.join(", ") : "Sin Dirección";

      const fechaCreacion = moment(pedido.fecha_creacion).format(
        "DD-MMM-YYYY HH:mm:ss",
      );

      const fechaImpresion = moment().format("DD-MMM-YYYY HH:mm:ss");

      const fechaConfirmacion = moment(this.FechaConfirmacion).format(
        "DD-MMM-YYYY HH:mm:ss",
      );
      // Construir el contenido HTML de la plantilla personalizada
      const contenidoHTML = `
    <!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Formato Pedido</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 20px;
      font-size: 12px;
    }

    .container {
      border: 1px solid #000;
      padding: 10px;
    }

    .header {
      display: flex;
      justify-content: space-between;
      border: 1px solid #000;

    }

    .logo-info {
      display: flex;
      align-items: flex-start;
      margin-top : 15px;
    }

    .logo-info img {
      height: 60px;
      margin-right: 10px;
    }

    .company-info {
      font-size: 11px;
      width: 100%;
    }

    .company-address {
      margin-left: 10px;
    }

    .company-name {
      font-size: 18px;
      font-weight: bold;
      text-align: center; /* Centrar título */
      padding: 0;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .correo{
      text-align: right;
      margin-right: 10px;
    }

    .pedido-box {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      text-align: center;
      border-left: 1px solid #000;
      border-right: 0;
      border-bottom: 0
      border-top: 0;
    }

    .pedido-box div {
     border-bottom: 1px solid #000;

      padding: 5px;
    }

    .cliente-info {
      margin-top: 10px;
    }

    .tabla-productos {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
      border: 1px solid #000;
    }

    .tabla-productos th,
    .tabla-productos td {
      border: 1px solid #000;
      padding: 6px;
      text-align: center;
    }

    .tabla-productos tbody td {
      border: none;
    }

    .agente-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 10px;
    }

    .agente-info div {
      margin-top: 5px;
    }

    .footer-section {
      display: flex;
      border-top: 1px solid #000;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      margin-top: 10px;
    }

    .observaciones {
      /*border: 1px solid #000;*/
      flex: 4;
      height: 60px;
      margin-top: 10px;
      padding: 5px;
    }

      .totales {
      flex: 1;
      padding: 10px;
     border-left: 1px solid #000;
    }

    .totales div {
      text-align: left;
      margin-bottom: 5px;
       border-bottom: 1px solid #000;
    }

    @media print {
      @page {
        margin: 5mm;
        margin-left: 5mm;
      }

      body {
        margin: 0;
        padding: 0;
      }

    }

  </style>
</head>
<body>
  <div class="container">
    <!-- Encabezado -->
   <div class="header">
  <div class="logo-info">
    <img src="${require("@/assets/prostasa-logo.png")}" alt="Logo Prostasa" />
  </div>
  <div class="company-info">
    <div class="company-name"><strong>GRUPO PROSTASA DE MEXICO</strong></div>
    <div class="company-address">
      SUCURSAL CULIACAN<br />
      CALLE MANUEL VALLARTA 2177, COL. CENTRO SINALOA<br />
      CULIACAN ROSALES, SINALOA, MEXICO C.P 80000<br />
      TEL. 667 275-45-87
    </div>
    <div class="correo">creditoycobranza.culiacan@prostasa.com</div>
  </div>
  <div class="pedido-box">
    <div><strong>PEDIDO</strong></div>
    <div><strong>CLN</strong>${pedido.id}</div>
    <div>${fechaCreacion}</div>
  </div>
</div>

    <!-- Cliente -->
    <div class="cliente-info">
      <div><strong>CLIENTE:</strong> (${pedido.codigo_cliente}) ${
        pedido.cliente
      }</div>
      <div><strong>DIRECCION:</strong> ${localizacion}</div>
      <div><strong>TELEFONOS:</strong> ${this.telefonos.join(", ")}</div>
      <div><strong>RFC:</strong> ${this.rfc}</div>
    </div>

    <!-- Tabla de productos -->
    <table class="tabla-productos">
      <thead>
        <tr>
          <th>CANTIDAD</th>
          <th>PRODUCTO</th>
          <th>CODIGO</th>
          <th>MARCA</th>
          <th>P.PUB.</th>
          <th>P.VTA.</th>
          <th>%IEPS</th>
          <th>%IVA</th>
          <th>IMPORTE</th>
        </tr>
      </thead>
      <tbody>
         ${productos
           .map((producto) => {
             const importe = producto.precio * producto.cantidad;
             return `
              <tr>
                <td>${producto.cantidad}</td>
                <td>${producto.nombre}</td>
                <td>${producto.codigo}</td>
                <td>${producto.laboratorio}</td>
                <td>$${this.formatoPrecio(producto.precio_publico)}</td>
                <td>$${this.formatoPrecio(producto.precio)}</td>
                <td>${producto.ieps}%</td>
                <td>${producto.iva}%</td>
                <td>$${this.formatoPrecio(importe)}</td>
              </tr>
            `;
           })
           .join("")}
        <!-- Agrega más filas aquí -->
      </tbody>
    </table>

    <!-- Agente y otros datos -->
    <div class="agente-info">
      <div class="cliente-info">
      <div><strong>AGENTE:</strong> ${pedido.vendedor}</div>
      <div><strong>RUTA:</strong> ${pedido.ruta}</div>
      <!--
      <div><strong>ORIGEN DEL PEDIDO:</strong></div>
      -->
      </div>
      <div class="cliente-info">
      <div><strong>AUTORIZA PEDIDO:</strong> ${this.autorizaPedido}</div>
      <div><strong>FECHA DE AUTORIZACION:</strong> ${fechaConfirmacion}</div>
      <div><strong>FECHA IMPRESION:</strong> ${fechaImpresion}</div>
      </div>
    </div>

     <!-- Observaciones y totales -->
    <div class="footer-section">
      <div class="observaciones">
        <div><strong>OBSERVACIONES:</strong> ${pedido.observaciones}</div>
        <div><strong>COMENTARIOS:</strong>
          <ul>
            ${this.comentariosImpresion
              .map((comentario) => `<li>${comentario.texto_comentario}</li>`)
              .join("")}
          </ul>
          </div>
      </div>
      <div class="totales">
        <div><strong>SUBTOTAL:</strong> $${this.formatoPrecio(subtotal)}</div>
        <div><strong>IEPS:</strong> $${this.formatoPrecio(totalIeps)}</div>
        <div><strong>IVA:</strong> $${this.formatoPrecio(totalIva)}</div>
        <div><strong>TOTAL:</strong> $${this.formatoPrecio(pedido.total)}</div>
      </div>
    </div>
  </div>
</body>
</html>

    `;

      // Abrir una nueva ventana para la impresión
      const ventana = window.open("", "_blank");

      // Escribir el contenido HTML en la nueva ventana
      ventana.document.open();
      ventana.document.write(contenidoHTML);
      ventana.document.close();

      // Esperar un poco para asegurarse de que el contenido se cargue
      setTimeout(() => {
        ventana.print(); // Abrir el cuadro de diálogo de impresión
        ventana.close(); // Cerrar la ventana después de imprimir
      }, 500);
    },

    async descargarPDF() {
      await this.getComentarios(this.item.id);
      await this.getHistorialObjeto(this.item.id);
      await this.getClienteTelefonosyRFC(this.item.idCliente);

      const pedido = this.item;
      const productos = this.item.productos.lista_productos;

      const subtotal = productos.reduce(
        (acc, p) => acc + p.precio * p.cantidad,
        0,
      );
      const totalIeps = productos.reduce(
        (acc, p) => acc + p.precio * p.cantidad * (p.ieps / 100),
        0,
      );
      const totalIva = productos.reduce(
        (acc, p) => acc + p.precio * p.cantidad * (p.iva / 100),
        0,
      );
      /*const localizacion =
        (pedido.localizacion?.direccion_linea_1 || "") +
        ", " +
        (pedido.localizacion?.direccion_linea_2 || "") +
        ", " +
        (pedido.localizacion?.ciudad || "") +
        " C.P. " +
        (pedido.localizacion?.codigo_postal || "");*/

      const loc = pedido.localizacion;

      const partes = [
        loc?.direccion_linea_1,
        loc?.direccion_linea_2,
        loc?.ciudad,
      ].filter(Boolean);

      if (loc?.codigo_postal) {
        partes.push(`C.P. ${loc.codigo_postal}`);
      }

      const localizacion = partes.length ? partes.join(", ") : "Sin Dirección";

      const fechaCreacion = pedido.fecha_creacion
        ? moment(pedido.fecha_creacion).format("DD-MMM-YYYY HH:mm:ss")
        : "";
      const fechaImpresion = moment().format("DD-MMM-YYYY HH:mm:ss");
      const fechaConfirmacion =
        this.FechaConfirmacion && this.FechaConfirmacion.trim()
          ? moment(this.FechaConfirmacion).isValid()
            ? moment(this.FechaConfirmacion).format("DD-MMM-YYYY HH:mm:ss")
            : ""
          : "";

      const logoBase64 =
        "data:image/webp;base64,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";

      // SOLO el contenido del body, sin <html>, <head> ni <body>
      const contenidoHTML = `
    <div class="container">
      <div class="header">
        <div class="logo-info">
          <img src="${logoBase64}" alt="Logo Prostasa" />
        </div>
        <div class="company-info">
          <div class="company-name"><strong>GRUPO PROSTASA DE MEXICO</strong></div>
          <div class="company-address">
            SUCURSAL CULIACAN<br />
            CALLE MANUEL VALLARTA 2177, COL. CENTRO SINALOA<br />
            CULIACAN ROSALES, SINALOA, MEXICO C.P 80000<br />
            TEL. 667 275-45-87
          </div>
          <div class="correo">creditoycobranza.culiacan@prostasa.com</div>
        </div>
        <div class="pedido-box">
          <div><strong>PEDIDO</strong></div>
          <div><strong>CLN</strong>${pedido.id}</div>
          <div>${fechaCreacion}</div>
        </div>
      </div>
      <div class="cliente-info">
        <div><strong>CLIENTE:</strong> (${pedido.codigo_cliente}) ${
        pedido.cliente
      }</div>
        <div><strong>DIRECCION:</strong> ${localizacion}</div>
        <div><strong>TELEFONOS:</strong> ${this.telefonos.join(", ")}</div>
        <div><strong>RFC:</strong> ${this.rfc}</div>
      </div>
      <table class="tabla-productos">
        <thead>
          <tr>
            <th>CANTIDAD</th>
            <th>PRODUCTO</th>
            <th>CODIGO</th>
            <th>MARCA</th>
            <th>P.PUB.</th>
            <th>P.VTA.</th>
            <th>%IEPS</th>
            <th>%IVA</th>
            <th>IMPORTE</th>
          </tr>
        </thead>
        <tbody>
          ${productos
            .map((producto) => {
              const importe = producto.precio * producto.cantidad;
              return `
              <tr>
                <td>${producto.cantidad}</td>
                <td>${producto.nombre}</td>
                <td>${producto.codigo}</td>
                <td>${producto.laboratorio}</td>
                <td>$${this.formatoPrecio(producto.precio_publico)}</td>
                <td>$${this.formatoPrecio(producto.precio)}</td>
                <td>${producto.ieps}%</td>
                <td>${producto.iva}%</td>
                <td>$${this.formatoPrecio(importe)}</td>
              </tr>
            `;
            })
            .join("")}
        </tbody>
      </table>
      <div class="agente-info">
        <div class="cliente-info">
          <div><strong>AGENTE:</strong> ${pedido.vendedor}</div>
          <div><strong>RUTA:</strong> ${pedido.ruta}</div>
        </div>
        <div class="cliente-info">
          <div><strong>AUTORIZA PEDIDO:</strong> ${this.autorizaPedido}</div>
          <div><strong>FECHA DE AUTORIZACION:</strong> ${fechaConfirmacion}</div>
          <div><strong>FECHA IMPRESION:</strong> ${fechaImpresion}</div>
        </div>
      </div>
      <div class="footer-section">
        <div class="observaciones">
          <div><strong>OBSERVACIONES:</strong> ${pedido.observaciones}</div>
          <div><strong>COMENTARIOS:</strong>
            <ul>
              ${this.comentariosImpresion
                .map((comentario) => `<li>${comentario.texto_comentario}</li>`)
                .join("")}
            </ul>
          </div>
        </div>
        <div class="totales">
          <div><strong>SUBTOTAL:</strong> $${this.formatoPrecio(subtotal)}</div>
          <div><strong>IEPS:</strong> $${this.formatoPrecio(totalIeps)}</div>
          <div><strong>IVA:</strong> $${this.formatoPrecio(totalIva)}</div>
          <div><strong>TOTAL:</strong> $${this.formatoPrecio(
            pedido.total,
          )}</div>
        </div>
      </div>
    </div>
    <style>
      body { font-family: Arial, sans-serif; margin: 20px; font-size: 12px; }
      .container { border: 1px solid #000; padding: 10px; }
      .header { display: flex; justify-content: space-between; border: 1px solid #000; }
      .logo-info { display: flex; align-items: flex-start; margin-top: 15px; }
      .logo-info img { height: 60px; margin-right: 10px; }
      .company-info { font-size: 11px; width: 100%; }
      .company-address { margin-left: 10px; }
      .company-name { font-size: 18px; font-weight: bold; text-align: center; padding: 0; margin: 0; display: flex; justify-content: center; align-items: center; }
      .correo{ text-align: right; margin-right: 10px; }
      .pedido-box { display: grid; grid-template-columns: repeat(1, 1fr); text-align: center; border-left: 1px solid #000; border-right: 0; border-top: 0; }
      .pedido-box div { border-bottom: 1px solid #000; padding: 5px; }
      .cliente-info { margin-top: 10px; }
      .tabla-productos { width: 100%; border-collapse: collapse; margin-top: 10px; border: 1px solid #000; }
      .tabla-productos th, .tabla-productos td { border: 1px solid #000; padding: 6px; text-align: center; }
      .tabla-productos tbody td { border: none; }
      .agente-info { display: flex; flex-wrap: wrap; justify-content: space-between; margin-top: 10px; }
      .agente-info div { margin-top: 5px; }
      .footer-section { display: flex; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000; border-bottom: 1px solid #000; margin-top: 10px; }
      .observaciones { flex: 4; height: 60px; margin-top: 10px; padding: 5px; }
      .totales { flex: 1; padding: 10px; border-left: 1px solid #000; }
      .totales div { text-align: left; margin-bottom: 5px; border-bottom: 1px solid #000; }
    </style>
  `;

      // Crear un contenedor temporal para el contenido HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = contenidoHTML;
      document.body.appendChild(tempDiv);

      console.log("tempDiv innerHTML:", tempDiv.innerHTML); // Depuración

      await html2pdf()
        .set({
          margin: 5,
          filename: `Pedido #${pedido.id}.pdf`,
          html2canvas: { scale: 2 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(tempDiv)
        .save();

      document.body.removeChild(tempDiv);
    },

    async getComentarios(idPedido) {
      try {
        const response = await axios.get(
          `/varios/get_comentarios?id_objeto=${idPedido}&tipo_objeto=pedido`,
        );
        this.comentariosImpresion = response.data;
      } catch (error) {
        console.error(error);
        this.comentariosImpresion = [];
      }
    },

    async getHistorialObjeto(idPedido) {
      try {
        const response = await axios.get(
          `/varios/get_historial_objeto?tipo_objeto=pedido&id_objeto=${idPedido}`,
        );
        this.historial = response.data.historial;
        // Filtrar el historial para encontrar el estado "confirmación"
        const confirmacion = this.historial.find((registro) => {
          const objeto = JSON.parse(registro.objeto); // Deserializar el campo objeto
          return objeto.estado === "confirmacion"; // Verificar el estado
        });

        console.log("Confirmación:", confirmacion);

        if (confirmacion) {
          // Obtener el nombre del usuario que puso el estado a "confirmación"
          const usuario = await this.getNombreUsuarioId(confirmacion.usuario);
          this.autorizaPedido = usuario.nombre; // Almacenar el nombre del usuario
          console.log("Nombre del usuario:", this.autorizaPedido);
        } else {
          this.autorizaPedido = " "; // Si no hay confirmación, mostrar un mensaje
        }

        if (confirmacion) {
          this.FechaConfirmacion = confirmacion.fecha_creacion;
        } else {
          this.FechaConfirmacion = " ";
        }
      } catch (error) {
        console.error("Error al obtener el historial:", error);
        this.autorizaPedido = "Error al obtener datos";
      }
    },

    async getNombreUsuarioId(id) {
      try {
        const response = await axios.get(`/usuarios/get_by_id/${id}`);
        return response.data; // Devuelve el objeto completo del usuario
      } catch (error) {
        console.error("Error al obtener el nombre del usuario:", error);
        return { nombre: " " }; // Devuelve un valor por defecto en caso de error
      }
    },

    async getClienteTelefonosyRFC(id_cliente) {
      try {
        const response = await axios.get(
          `/clientes/get_domicilio_fiscal?id_cliente=${id_cliente}`,
        );
        this.telefonos = response.data.telefonos;
        this.telefonos = this.telefonos.split(",");

        this.rfc = response.data.rfc;
      } catch (error) {
        console.error("Error al obtener telefonos del cliente:", error);
      }
    },

    async desplegarPedido() {
      try {
        const response = await axios.get(
          `/varios/get_comentarios?id_objeto=${this.item.id}&tipo_objeto=pedido`,
        );
        this.comentariosPedido = response.data;
        // console.log(this.comentarios);
      } catch (error) {
        console.error(error);
      }

      this.dialogVerPedido = true;
    },
    cerrarDialog() {
      this.dialog = false;
      this.dialogVerPedido = false;
      this.dialogVerFacturasPendientesView = false;
    },
    getIvaIeps(precioProducto, impuesto) {
      // Formatear el número utilizando una función personalizada
      const numero = parseFloat(precioProducto);
      let precio = 0;

      if (impuesto > 0) {
        const impuestoDecimal = impuesto / 100;
        precio = numero * impuestoDecimal; // Limitar a 2 decimales

        return precio;
      } else {
        return 0;
      }
    },
    async crearCotizacion() {
      const pedido = this.item;
      const productos = this.item.productos.lista_productos;
      const currentDate = moment()
        .locale("es")
        .format("dddd, DD [de] MMMM [de] YYYY");
      this.formatDate =
        currentDate.charAt(0).toUpperCase() + currentDate.slice(1); // Capitalize first letter
      // console.log(this.formatDate);
      const subtotalPedido = productos
        .reduce(
          (total, producto) =>
            total + parseFloat(producto.subtotal.replace(",", "")),
          0,
        )
        .toFixed(2);
      const iepsTotal = productos
        .reduce(
          (total, producto) =>
            total +
            this.getIvaIeps(producto.subtotal.replace(",", ""), producto.ieps),
          0,
        )
        .toFixed(2);
      const ivaTotal = productos
        .reduce(
          (total, producto) =>
            total +
            this.getIvaIeps(producto.subtotal.replace(",", ""), producto.iva),
          0,
        )
        .toFixed(2);
      const totalPedido = (
        parseFloat(subtotalPedido) +
        parseFloat(iepsTotal) +
        parseFloat(ivaTotal)
      ).toFixed(2);
      console.log(pedido);

      // Crear una ventana emergente
      const ventana = window.open("", "_blank");

      // Construir el contenido HTML de la vista previa de impresión
      const contenidoHTML = `
      <!doctype html>
<html lang="es">

<head>

    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Cotizacion</title>
    <!-- Enlace al archivo CSS de Bootstrap -->
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet"
        integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css">
    <style>
        @import url('https://fonts.googleapis.com/css2?family=Arvo:wght@700&display=swap');

        body {
            font-family: Arial, sans-serif;
            display: flex;
            flex-direction: column;
            height: 100vh;
            margin: 0;
        }

        .content {
            flex: 1;
        }

        .table-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 11px;
        }

        .tabla-th {
            background-color: #f2f2f2;
            padding: 8px;
            text-align: left;
        }

        .tabla-td {
            padding: 8px;
            text-align: left;
        }

        .datos-table {
            width: 100%;
            border-collapse: collapse;
        }

        .datos-th {
            padding: 8px;
            font-size: 10px;
            text-align: left;
        }

        .datos-td {
            padding: 8px;
            font-size: 14px;
            text-align: left;
        }

        .invoice-title {
            font-family: 'Arvo', sans-serif;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            background-color: #28B2BB;
            color: white;
            padding: 10px 0;
            font-size: 30px;
            margin-top: 20px;
            height: 80px;
        }

        p.right-align {
            text-align: right;
            margin: 15px;
            /* Ajusta el valor de margin según tus necesidades */
        }

        p {
            margin: 15px;
            /* Ajusta el valor de margin según tus necesidades */
        }

        .data-total {
            background-color: #28B2BB;
            color: white;
            padding: 8px;
            text-align: right;
            font-weight: bold;
        }

        .footer-rectangle {
            background-color: #28B2BB;
            width: 80%;
            /* 2/3 of the page width */
            padding: 20px 20px;
            color: white;
            position: absolute;
            bottom: 20px;
            /* margin from the bottom */
        }

        .footer-content {
            margin: 0;
            padding: 0 20px;
        }

        /* .footer-info {
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
            position: absolute;
            bottom: 120px;
            width: 100%;
        } */

        .socialfb-text {
            color: #1668c7;
            font-size: 12px;
        }

        .telephone-text {
            font-size: 24px;
            font-family: 'Arvo', sans-serif;
            margin-right: 15px;
            text-align: right;
        }

        .invoice-date {
            background-color: grey;
            display: inline-block;
            padding: 1px 15px;
            font-size: 18px;
            color: white;
        }

        .text-right {
            text-align: right;
            margin-right: 15px;
        }

        .socialmail-text {
            color: #1668c7;
            font-size: 14px;
        }

        .social-link {
            color: #1668c7;
            text-decoration: none;
            /* Esto elimina el subrayado del enlace */
        }

        .totals {
            font-size: 14px;
            position: absolute;
            bottom: 170px;
            /* Adjusted to be above the adjusted salesman line */
            right: 0;
        }

        .img-logo {
            width: 140px;
            height: 140px;
        }

        .custom-position {
            position: absolute;
            top: 50%;
            left: 15%;
            transform: translate(-50%, -30%);
        }

        i {
            padding-left: 14px;
            padding-right: 8px;
        }

        @media print {

            .invoice-title,
            .footer-rectangle,
            .tabla-th,
            .rectangulo-footer {
                background-color: #28B2BB !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }

            .invoice-date {
                background-color: grey;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }

            .tabla-th {
                background-color: #f2f2f2 !important;
            }
        }
    </style>
</head>

<body class="d-flex">
    <div class="row">
        <div class="invoice-title">COTIZACIÓN</div>
    </div>
    <div class="position-relative">
        <img src="${
          this.logoURL
        }" alt="Logo" class="img-logo img-fluid z-1 custom-position" />
    </div>

    <div class="d-flex flex-column mt-2">
        <div class="p-2 telephone-text"><i class="bi bi-telephone-fill"></i><strong> (686) 563-2834</strong></div>
        <div class="p-2 text-right"><span class="invoice-date">${
          this.formatDate
        }</span></div>
    </div>

    <div class="d-flex flex-column">
        <div class="p-1"><strong>${pedido.cliente}</strong></div>
        <div class="p-1">PRESENTE.-</div>
        <div class="p-1 mb-2">En atención a usted(es), ponemos a su consideración y disposición la
            presente cotización de los siguientes productos y/o servicios
        </div>
        <table class="table-table table table-borderless table-sm">
            <thead>
                <tr>
                    <th class="tabla-th">Cantidad</th>
                    <th class="tabla-th">Descripción</th>
                    <th class="tabla-th">Precio unitario</th>
                    <th class="tabla-th">Neto descuento</th>
                    <th class="tabla-th">IEPS</th>
                    <th class="tabla-th">IVA</th>
                    <th class="tabla-th">Importe</th>
                </tr>
            </thead>
            <tbody>
                ${productos
                  .map(
                    (producto) => `
                <tr>
                    <td class="tabla-td">${producto.cantidad}</td>
                    <td class="tabla-td">${producto.nombre}</td>
                    <td class="tabla-td">$${this.formatoPrecio(
                      producto.precio,
                    )}</td>
                    <td class="tabla-td">$${this.formatoPrecioDescuento(
                      producto.precio,
                      producto.descuento,
                    )}</td>
                    <td class="tabla-td">${producto.ieps}%</td>
                    <td class="tabla-td">${producto.iva}%</td>
                    <td class="tabla-td">$${producto.subtotal}</td>
                </tr>
                `,
                  )
                  .join("")}
            </tbody>
        </table>
    </div>

    <strong class="mt-3" style="font-size: 14;">Datos y correo para pagos:</strong>
    <div class="d-flex justify-content-between">
        <div class="p-1">
            <table class="datos-table table table-borderless table-sm">
                <thead>
                    <tr>
                        <th class="datos-th">Banco:</th>
                        <th class="datos-th">Moneda:</th>
                        <th class="datos-th">Cuenta CLABE:</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="datos-td">Banamex</td>
                        <td class="datos-td">MXN</td>
                        <td class="datos-td">002 020 48880052279 9</td>
                    </tr>
            </table>
        </div>
        <div class="p-1">
            <strong style="font-size: 14px;">Otras opciones<br>de pago:</strong>
            <img src="${
              this.visamastercard
            }" alt="VisaMastercard" class="img-fluid" style="width: 70px;" />
        </div>
        <div class="d-flex flex-column">
            <div class="p1" style="font-size: small;"><strong>Subtotal:</strong>$${subtotalPedido}</div>
            <div class="p1" style="font-size: small;"><strong>IEPS:</strong>$${iepsTotal}</div>
            <div class="p1" style="font-size: small;"><strong>IVA:</strong>$${ivaTotal}</div>
            <div class="p1" style="font-size: medium;"><strong>Total:</strong>$${totalPedido}</div>
        </div>
    </div>
    <strong style="font-size: 14;">Términos y condiciones:</strong>
    <div class="d-flex flex-column mt-3">
        <div class="p1"> 1) Precios sujetos a cambios sin previo aviso.</div>
        <div class="p1"> 2) Aplican restricciones y/o cargos por fletes y otros impuestos.</div>
        <div class="p1"> 3) No se aceptan devoluciones.</div>
    </div>

    <div class="footer-info mt-3">
        <div class="d-flex mb-3">
            <div class="me-auto"><span>Atentamente: <br>${
              pedido.vendedor
            }</span></div>
            <div class="align-self-end"><span class="socialfb-text"><i class="bi bi-facebook"
                        style="font-size: 20px;"></i><strong><a
                            href="https://www.facebook.com/centralexpressdecontroldeplagas"
                            class="social-link">facebook.com/centralexpressdecontroldeplagas</a></strong></span></div>
            <div class="align-self-end"><i class="bi bi-envelope" style="font-size: 20px; color: #63dee7;"></i><span
                    class="socialmail-text"><strong>ventas@centralexpress.mx</strong></span></div>
        </div>
    </div>

    <div class="mt-auto footer-rectangle">
        <strong>Central Express de Control de Plagas, SA de CV</strong>
        <br>
        <span style="font-size: 12px;">Blvd. Lázaro Cárdenas 526, Ex Ejido Coahuila, C.P. 21360, Mexicali, Baja
            California, México</span>
    </div>
</body>

</html>`;

      // Escribir el contenido HTML en la ventana emergente
      ventana.document.open();
      ventana.document.write(contenidoHTML);
      ventana.document.close();

      // Esperar un poco para asegurarnos de que la ventana se haya abierto correctamente
      setTimeout(() => {
        // Imprimir la ventana emergente
        ventana.print();
      }, 500);
    },
    formatoPrecio(precioProducto) {
      // Formatear el número utilizando una función personalizada
      const numero = parseFloat(precioProducto);
      // console.log(numero);
      let precio = 0;

      precio = numero.toFixed(2); // Limitar a 2 decimales
      const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
      const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

      // Formatear la parte entera con separador de miles
      const parteEnteraFormateada = parteEntera.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ",",
      );

      return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;
    },
    async regresarPedido() {
      try {
        const response = await axios.put(
          `/pedidos/regresar?nuevo_estado=${this.estado}&id_pedido=${this.item.id}`,
        );
        console.log(response.data);
        alert("Se cambio el estado del pedido");
        this.$emit("pedidoModificado");
      } catch (error) {
        console.error(error);
        alert(error.response.data.detail);
      }
    },
    pedidoModificado() {
      this.$emit("pedidoModificado");
      this.dialog = false;
    },
    async cambiarPrioridad() {
      try {
        const response = await axios.post(
          `/pedidos/cambiar_prioridad?id_pedido=${this.item.id}`,
        );
        console.log(response.data);
        alert("Se cambio la prioridad");
        this.$emit("pedidoModificado");
      } catch (error) {
        console.error(error);
        alert(error.response.data.detail);
      }
    },
    async cancelarPedido() {
      try {
        const response = await axios.post(
          `/pedidos/avanzar_pedido?id_pedido=${this.item.id}&nuevo_estado=cancelado`,
        );
        console.log(response.data);
        alert("Pedido cancelado");
        this.$emit("pedidoModificado");
      } catch (error) {
        console.error(error);
        alert(error.response.data.detail);
      }
    },
    getOpciones() {
      if (this.item.abierto) {
        //Si el pedido esta cerrado no se muestra la opcion de asociar factura
        this.items = [
          {
            title: "Asociar factura",
            component: "AsociarFactura",
          },
          // {
          //   title: "Ver pedido",
          //   component: "VerPedido",
          // },
          {
            title: "Agregar comentario",
            component: "CrearComentario",
          },
        ];
      } else {
        this.items = [
          // {
          //   title: "Ver pedido",
          //   component: "VerPedido",
          // },
          {
            title: "Agregar comentario",
            component: "CrearComentario",
          },
        ];
      }
    },
    seleccionarComponent(item) {
      if (item.component) {
        this.selectedComponent = item.component;
        this.dialog = true;
      }
    },
    ...mapActions(["setPerfil"]),
    openPerfil(perfil) {
      this.setPerfil(perfil);
      this.$emit("openPerfil"); // Emit an event to the parent component
    },
    precioDescuento(precioProducto, descuento) {
      // Formatear el número utilizando una función personalizada
      const numero = parseFloat(precioProducto);
      // console.log(numero);
      let precio = 0;

      if (descuento > 0) {
        const descuentoDecimal = descuento / 100;
        precio = (numero * (1 - descuentoDecimal)).toFixed(2); // Limitar a 2 decimales
        const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
        const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

        // Formatear la parte entera con separador de miles
        const parteEnteraFormateada = parteEntera.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ",",
        );

        return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;
      } else {
        precio = numero.toFixed(2); // Limitar a 2 decimales
        const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
        const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

        // Formatear la parte entera con separador de miles
        const parteEnteraFormateada = parteEntera.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ",",
        );

        return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;
      }
    },
    formatoPrecioDescuento(precioProducto, descuento) {
      // Formatear el número utilizando una función personalizada
      const numero = parseFloat(precioProducto);
      // console.log(numero);
      let precio = 0;

      if (descuento > 0) {
        const descuentoDecimal = descuento / 100;
        precio = (numero * (1 - descuentoDecimal)).toFixed(2); // Limitar a 2 decimales
        const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
        const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

        // Formatear la parte entera con separador de miles
        const parteEnteraFormateada = parteEntera.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ",",
        );

        return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}(-${descuento}%)`;
      } else {
        precio = numero.toFixed(2); // Limitar a 2 decimales
        const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
        const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

        // Formatear la parte entera con separador de miles
        const parteEnteraFormateada = parteEntera.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ",",
        );

        return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;
      }
    },
  },
  mounted() {
    this.getOpciones();
  },
};
</script>
